export class RechargeRequestError implements Error {
  name = 'RechargeRequestError';
  message: string;
  status?: number;

  constructor(message: string, status?: number) {
    this.message = message;
    this.status = status;
  }
}
